<template>
  <div>
    <b-row v-if="firstSlide">
      <b-col cols="5">
        <div
          style="widht:80%;min-height:470px;background-color:#3DDC97;padding:20px"
        >
          <h1 class="text-white">
            {{ $t("trainingTest.modalText") }}
          </h1>
        </div>
      </b-col>
      <b-col
        cols="7"
        style="
            display: grid;
            align-items: center;
          "
      >
        <div class="text-center" style="padding:60px">
          <b
            ><i>{{ $t("trainingTest.modalDescription") }}</i></b
          >
        </div>
        <div style="justify-self:center">
          <b-btn
            @click="nextSlideTwo"
            style="width: 260px;
            height: 63px;
            background: #3DDC97;
            color: white;
            margin-bottom: -60px;"
            size="lg"
            variant="outline-success"
            ><b>{{ $t("startBtnText") }}</b></b-btn
          >
        </div>
      </b-col>
    </b-row>

    <b-row v-if="secondSlide">
      <b-col cols="5">
        <div
          style="widht:80%;height:465px;background-color:#3DDC97;padding:15px"
        >
          <h1
            style="font-weight: 700;
                font-size: xxx-large;"
            class="text-white mb-3"
          >
            {{ $t("certifications.question") }}
            {{ currentQuestionIndex + 1 }}
          </h1>
          <p
            style="
                overflow-y: auto;
                height: 325px;
                font-size: 1.3vw;
                line-height:inherit"
            class="text-white"
          >
            {{ currentQuestion }}
          </p>
        </div>
      </b-col>

      <b-col cols="7">
        <b-row>
          <b-col cols="12" style="min-height:405px" class="text-center">
            <div
              v-for="(answer, answerIndex) in currentAnswers"
              :key="answerIndex"
              class="text-left mb-1"
              style="text-align-last: center;"
            >
              <b-btn
                :id="answerIndex"
                :class="getActiveClass(answer)"
                style="width: 320px;"
                @click="onSelectOption(answer)"
                variant="outline-dark"
                :disabled="showNextBtn"
              >
                <span>{{ answer.answer[selectedLanguage] }} </span>
              </b-btn>
            </div>
            <div v-if="showErrorText">
              <!-- <h5> -->
              <b class="text-danger">{{ $t("trainingTest.wrong") }}</b>
              <br />
              <b
                >{{ $t("trainingTest.correctionText") }}
                <br />
                {{ correctAnsString[selectedLanguage] }}</b
              >
              <!-- <p>{{ negativeMessageFeedback[selectedLanguage] }}</p> -->
              <p v-html="sanitizeHtml(negativeMessageFeedback[selectedLanguage])"></p>
              <!-- </h5> -->
            </div>
            <div v-if="isCorrectAns">
              <!-- <h5> -->
              <b class="text-success">{{ $t("trainingTest.correct") }} </b>
              <!-- <p>{{ positiveMessageFeedback[selectedLanguage] }}</p> -->
              <p v-html="sanitizeHtml(positiveMessageFeedback[selectedLanguage])"></p>
              <!-- </h5> -->
            </div>
          </b-col>
          <b-col cols="12">
            <div class="text-center" style="justify-content:center">
              <b-btn
                v-if="!showNextBtn"
                style="width: 260px;
                min-height: 55px;
                color: white;
                background-color: #3ddc97;"
                size="lg"
                @click="checkAnswer"
                :disabled="disableCheckAnswerBtn"
                variant="outline-success"
              >
                <b>{{ $t("trainingTest.check") }}</b>
              </b-btn>
              <!-- margin-bottom: -60px; -->
              <b-btn
                v-if="showNextBtn"
                style="width: 260px;
                min-height: 55px;
                color: white;
                background-color: #3ddc97;"
                size="lg"
                @click="nextQuestion"
                :disabled="disableCheckAnswerBtn"
                variant="outline-success"
              >
                <b
                  v-if="
                    this.currentQuestionIndex < this.testQuestions.length - 1
                  "
                  >{{ $t("trainingTest.next") }}</b
                >
                <b v-else>{{ $t("trainingTest.finish") }}</b>
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- footer -->
    <b-row>
      <b-col cols="12" class="mt-2">
        <div class="d-flex">
          <div style="width:15%">
            <b-img fluid :src="require('./logoEthixBase.png')" />
          </div>
          <div
            style="display: flex;
                align-self: center;
                margin: auto;"
            class="text-center"
          >
            <b>{{ $t("trainingTest.confidential") }}</b>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import moment from "moment";
import { EventBus } from "@/event-bus.js";

import _ from "lodash";
export default {
  name: "trainingQuestionModal",
  data() {
    return {
      disableOptionsBtn: false,
      disableCheckAnswerBtn: true,
      firstSlide: true,
      secondSlide: false,
      selectOption: false,
      showErrorText: false,
      isCorrectAns: false,
      correctAnsString: null,
      saveAnsValue: null,
      showNextBtn: false,
      practiceTestData: null,
      testQuestions: [],
      startTest: false,
      currentQuestionIndex: 0,
      currentQuestion: null,
      currentAnswers: null,
      currentAnswerType: 1,
      currentExamAttempt: 0,
      selectedAnswers: [],
      noOfSteps: 0,
      positiveMessageFeedback: null,
      negativeMessageFeedback: null,
    };
  },
  mounted() {
    // fetch current training tests on component load
    if (this.linkPracticeTest) {
      const parseSchema = JSON.parse(this.linkPracticeTest.schema);
      this.practiceTestData = parseSchema;
      this.testQuestions = parseSchema.formSection[0].formElements;

       if (
        parseSchema.formConfiguration.exam.examUniqueAnswersPerAttempt &&
        parseSchema.formConfiguration.exam.examUniqueAnswersPerAttempt > 0
      ) {
      
        this.testQuestions = this.getRandom(
          parseSchema.formSection[0].formElements,
          parseSchema.formConfiguration.exam.examUniqueAnswersPerAttempt
        );
      }

      this.currentQuestion = this.testQuestions[this.currentQuestionIndex].questionText[this.selectedLanguage];
      this.positiveMessageFeedback = this.testQuestions[this.currentQuestionIndex].positiveMessage;
      this.negativeMessageFeedback = this.testQuestions[this.currentQuestionIndex].negativeMessage;
      this.currentAnswers = this.testQuestions[this.currentQuestionIndex].answers;
      this.noOfSteps = this.testQuestions.length;
      // console.log( this.currentAnswers, "all Answers" );

     
    }
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    }),
    ...mapState(["selectedAnswersForExams"]),
  },

  methods: {
    sanitizeHtml,
    nextSlideTwo() {
      this.firstSlide = false;
      this.secondSlide = true;
    },

    getRandom(arr, n) {
      var result = new Array(n),
        len = arr.length,
        taken = new Array(len);
      if (n > len)
        throw new RangeError("getRandom: more elements taken than available");
      while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },

    onSelectOption(answer) {
      // set selected answer value from schema
      this.saveAnsValue = answer.answer;
      // console.log(this.saveAnsValue, "selected Answer ");
      this.selectOption = true;
      if (this.saveAnsValue != null) {
        this.disableCheckAnswerBtn = false;
      }
    },

    getActiveClass(answer) {
      // change colors of option btns on check
      let activeClass = "white";
      if (this.saveAnsValue === answer.answer) {
        activeClass = "gray";
        if (this.isCorrectAns) {
          activeClass += " green";
        } else if (this.showErrorText) {
          activeClass += " red";
        }
      }

      return activeClass;
    },
    // breakLineString(){
    //   this.negativeMessageFeedback.split("\n")
    // },
    checkAnswer() {
      let selectedAnswer = this.currentAnswers.find(
        (x) => x.answer === this.saveAnsValue
      );
      // console.log( 'find correct option', this.currentAnswers.find( x => x.isCorrectAnswer == "Yes" ) )
      if (selectedAnswer.isCorrectAnswer === "Yes") {
        // correct answers conditions
        this.isCorrectAns = true;
        this.showNextBtn = true;
        this.showErrorText = false;
      } else {
        // wrong answer states
        this.showErrorText = true;
        this.showNextBtn = true;
        this.isCorrectAns = false;
        let correctAnswer = this.currentAnswers.find(
          (x) => x.isCorrectAnswer == "Yes"
        );
        this.correctAnsString = correctAnswer.answer;
      }
      // console.log("this.negativeMessageFeedback", this.negativeMessageFeedback);
      // console.log("this.positiveMessageFeedback", this.positiveMessageFeedback);
    },

    nextQuestion() {
      if (this.currentQuestionIndex < this.testQuestions.length - 1) {
        // condition run till last index of question
        this.showNextBtn = false;
        this.showErrorText = false;
        this.disableCheckAnswerBtn = true;
        this.isCorrectAns = false;
        this.currentQuestionIndex++;
        this.currentQuestion = this.testQuestions[
          this.currentQuestionIndex
        ].questionText[this.selectedLanguage];

        this.currentAnswers = this.testQuestions[
          this.currentQuestionIndex
        ].answers;
        this.positiveMessageFeedback = this.testQuestions[
          this.currentQuestionIndex
        ].positiveMessage;
        this.negativeMessageFeedback = this.testQuestions[
          this.currentQuestionIndex
        ].negativeMessage;
      } else {
        // modal close when all questions are show
        EventBus.$emit("closeTrainingQuestionModal", "");
      }
    },
  },
  props: {
    linkPracticeTest: Object,
  },
};
</script>

<style>
/* initital classes on options */
.white {
  background-color: white;
}
.gray {
  background-color: gray;
  color: white;
}
/* on check answer  */
.red {
  background-color: red !important;
  color: white !important;
}
.green {
  background-color: green !important;
  color: white !important;
}
/* @hover */
.white:hover {
  background-color: white;
  color: black;
}
.gray:hover {
  background-color: gray;
  color: white;
}
</style>
